// /* eslint-disable jsx-a11y/anchor-is-valid */
// import React, { useEffect, useRef } from 'react'
// import ApexCharts, { ApexOptions } from 'apexcharts'
// import { KTIcon } from '../../../helpers'
// import { getCSSVariableValue } from '../../../assets/ts/_utils'
// import { Dropdown1 } from '../../content/dropdown/Dropdown1'
// import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

// type Props = {
//   className?: string
//   chartColor?: string
//   chartHeight?: string
//   title?: string
//   data?: any
//   note?: string // ← Add this line
// }


// const MixedWidget7C1: React.FC<Props> = ({
//   className,
//   data,
//   title,
//   chartColor = 'success',
//   chartHeight = '200px',
//   note
// }) => {
//   const chartRef = useRef<HTMLDivElement | null>(null)
//   const { mode } = useThemeMode()
//   const refreshChart = () => {
//     if (!chartRef.current) {
//       return
//     }

//     const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, data))
//     if (chart) {
//       chart.render()
//     }

//     return chart
//   }
//   useEffect(() => {
//     const chart = refreshChart()
//     return () => {
//       if (chart) {
//         chart.destroy()
//       }
//     }
//   }, [chartRef, mode, data]) // Add data here

//   return (
//     <div className={`card ${className}`}>
//       {/* begin::Beader */}
//       {/* <div className='card-header border-0'>
//         <h3 className='card-title align-items-start flex-column'>
//           <span className='card-label fw-bold fs-3 mb-1'>{title}</span>
//         </h3>
//       </div> */}
//       {/* end::Header */}

//       {/* begin::Body */}
//       <div className='card-body d-flex flex-column'>
//         <div className='flex-grow-1'>
//           <div ref={chartRef} className='mixed-widget-4-chart'></div>
//         </div>

//         <div className=''>
//           {note && (
//             <p className='text-center fs-6  '>
//               {note}
//             </p>
//           )}


//           {/* <a
//             href='#'
//             onClick={(e) => e.preventDefault()}
//             className={`btn btn-${chartColor} w-100 py-3`}
//           >
//             View
//           </a> */}
//           <div className='card-header border-0 d-flex justify-content-center'>
//             <h3 className='card-title mb-0'>
//               <span className='card-label fw-bold fs-3'>{title}</span>
//             </h3>
//           </div>

//         </div>
//       </div>
//       {/* end::Body */}
//     </div>
//   )
// }

// const chartOptions = (chartColor: string, chartHeight: string, data?: any): ApexOptions => {
//   const baseColor = getCSSVariableValue('--bs-' + chartColor)
//   const lightColor = getCSSVariableValue('--bs-' + chartColor + '-light')
//   const labelColor = getCSSVariableValue('--bs-gray-700')

//   return {
//     series: [Number(((data || 0.74) * 100).toFixed(2))],
//     chart: {
//       fontFamily: 'inherit',
//       height: chartHeight,
//       type: 'radialBar',
//     },
//     plotOptions: {
//       radialBar: {
//         hollow: {
//           margin: 0,
//           size: '65%',
//         },
//         dataLabels: {
//           name: {
//             show: false,
//             fontWeight: '700',
//           },
//           value: {
//             color: labelColor,
//             fontSize: '30px',
//             fontWeight: '700',
//             offsetY: 12,
//             show: true,
//             formatter: function (val) {
//               return val + '%'
//             },
//           },
//         },
//         track: {
//           background: lightColor,
//           strokeWidth: '100%',
//         },
//       },
//     },
//     colors: [baseColor],
//     stroke: {
//       lineCap: 'round',
//     },
//     labels: ['Progress'],
//   }
// }

// export { MixedWidget7C1 }




/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef } from 'react'
import ApexCharts, { ApexOptions } from 'apexcharts'
import { KTIcon } from '../../../helpers'
import { getCSSVariableValue } from '../../../assets/ts/_utils'
import { Dropdown1 } from '../../content/dropdown/Dropdown1'
import { useThemeMode } from '../../layout/theme-mode/ThemeModeProvider'

type Props = {
  className?: string
  chartColor?: string
  chartHeight?: string
  title?: string
  data?: any
  note?: string // ← Add this line
}


const MixedWidget7C1: React.FC<Props> = ({
  className,
  data,
  title,
  chartColor = 'success',
  chartHeight = '200px',
  note
}) => {
  const chartRef = useRef<HTMLDivElement | null>(null)
  const { mode } = useThemeMode()
  const refreshChart = () => {
    if (!chartRef.current) {
      return
    }

    const chart = new ApexCharts(chartRef.current, chartOptions(chartColor, chartHeight, data))
    if (chart) {
      chart.render()
    }

    return chart
  }
  useEffect(() => {
    const chart = refreshChart()
    return () => {
      if (chart) {
        chart.destroy()
      }
    }
  }, [chartRef, mode, data]) // Add data here

  return (
    <div className={`card ${className}`}>
      {/* begin::Beader */}
      {/* <div className='card-header border-0'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>{title}</span>
        </h3>
      </div> */}
      {/* end::Header */}

      {/* begin::Body */}
      <div className='card-body d-flex flex-column'>
        <div className='flex-grow-1'>
          <div ref={chartRef} className='mixed-widget-4-chart'></div>
        </div>

        <div className=''>
          {note && (
            <p className='text-center fs-6  '>
              {note}
            </p>
          )}


          {/* <a
            href='#'
            onClick={(e) => e.preventDefault()}
            className={`btn btn-${chartColor} w-100 py-3`}
          >
            View
          </a> */}
          <div className='card-header border-0 d-flex justify-content-center'>
            <h3 className='card-title mb-0'>
              <span className='card-label fw-bold fs-3'>{title}</span>
            </h3>
          </div>

        </div>
      </div>
      {/* end::Body */}
    </div>
  )
}

const chartOptions = (chartColor: string, chartHeight: string, data?: any): ApexOptions => {
  const baseColor = getCSSVariableValue('--bs-' + chartColor)
  const lightColor = getCSSVariableValue('--bs-' + chartColor + '-light')
  const labelColor = getCSSVariableValue('--bs-gray-700')

  return {
    // series: [Number(((data || 0.74) * 100).toFixed(2))],
    series: [Number((data * 100).toFixed(2))],
    chart: {
      fontFamily: 'inherit',
      height: chartHeight,
      type: 'radialBar',
    },
    plotOptions: {
      radialBar: {
        hollow: {
          margin: 0,
          size: '65%',
        },
        dataLabels: {
          name: {
            show: false,
            fontWeight: '700',
          },
          value: {
            color: labelColor,
            fontSize: '30px',
            fontWeight: '700',
            offsetY: 12,
            show: true,
            formatter: function (val) {
              return val + '%'
            },
          },
        },
        track: {
          background: lightColor,
          strokeWidth: '100%',
        },
      },
    },
    colors: [baseColor],
    stroke: {
      lineCap: 'round',
    },
    labels: ['Progress'],
  }
}

export { MixedWidget7C1 }
